import * as Types from '../types';

interface ClientUserAgreementGetParams {
  productName: string;
  productAccessType: string;
  productVersion: string;
  ccCountry: string;
  region: string;
  agreementType: string;
  agreementVersion?: string | null;
}

export function clientUserAgreementGet({
  productName,
  productAccessType,
  productVersion,
  ccCountry,
  region,
  agreementType,
  agreementVersion,
}: ClientUserAgreementGetParams): {
  type: string;
  productName: string;
  productAccessType: string;
  productVersion: string;
  ccCountry: string;
  region: string;
  agreementType: string;
  agreementVersion: string | null;
} {
  return {
    type: Types.REQ_USER_AGREEMENT_GET,
    productName,
    productAccessType,
    productVersion,
    ccCountry,
    region,
    agreementType,
    agreementVersion: agreementVersion || null,
  };
}

export function clientUserAgreementAcceptedSet(
  userId: string,
  agreementId: string,
): { type: string; userId: string; agreementId: string } {
  return {
    type: Types.REQ_USER_AGREEMENT_ACCEPTED_SET,
    userId,
    agreementId,
  };
}

export function clientUserAgreementAcceptedGet(
  userId: string,
  agreementId: string,
): { type: string; userId: string; agreementId: string } {
  return {
    type: Types.REQ_USER_AGREEMENT_ACCEPTED_GET,
    userId,
    agreementId,
  };
}

export function userAgreementStowe(object: unknown): { type: string; data: unknown } {
  return {
    type: Types.CLIENT_USER_AGREEMENT_STOWE,
    data: object,
  };
}

export function userHasAgreed(): { type: string; data: string; isEulaAgreed: boolean } {
  return {
    type: Types.CLIENT_USER_HAS_AGREED,
    data: '',
    isEulaAgreed: true,
  };
}

export function userHasNotAgreedYet(agreementId: string): {
  type: string;
  data: string;
  isEulaAgreed: boolean;
} {
  return {
    type: Types.CLIENT_USER_HAS_NOT_AGREED_YET,
    data: agreementId,
    isEulaAgreed: false,
  };
}
